export const LINKS = [
  { text: 'Qui suis-je ?', href: '/who-am-i' },
  { text: 'Compétences', href: '/skills' },
  { text: 'Projets', href: '/projects' },
  { text: 'Expérience', href: '/experience' },
]
